export default "__VITE_ASSET__CgpFEH8M__"